import _ from "lodash"
const { location = {} } = window || {}

export const getFlagCheckPathSAAS = () => {
  window?.sidebarRoute?.array.forEach((element) => {})
  const NAV_URL_SAAS_API_COMMON_CHECK_PATH = [
    "/content/payment_gateway",
    "/connectorSettings/PaymentGatewayConfig/",
    "/user-management/tenant_role_permission/",
    "/master-data/locations/hierarchyMapping/",
    "/master-data/locations/hierarchy/",
    "/master-data/locations/group/",
    "/master-data/locations_g/groups/",
    "/master-data/locations_h/hierarchy/",
    "/master-data/locations_hm/hierarchyMapping/",
    "/master-data/locations/",
    "/master-data/products/",
    "/master-data/products/groups/",
    "/master-data/products/hierarchy/",
    "/master-data/products/productMapping/",
    "/master-data/products/attribute/",
    "/master-data/products_g/groups/",
    "/master-data/products_h/hierarchy/",
    "/master-data/products_pm/productMapping/",
    "/master-data/products_attr/attribute/",
    "/master-data/offers/",
    "/master-data/discounts/",
    "/master-data/storage/Vendors/",
    "/master-data/storage/Vendorslist/",
    "/master-data/Storage/Vendors/",
    "/master-data/storage/storageunit/",
    "/master-data/Storage/createupdatestorage",
    "/inventory/store/inventory/",
    "/inventory/store/adjustments/",
    "/inventory/store/suppliers/",
    "/inventory/store/purchase/",
    "/inventory/store/purchases_history/",
    "/inventory/store/stock_report/",
    "/inventory_storage/storage/inventory/",
    "/inventory_storage/storage/adjustments/",
    "/autonomous-store/sdc/entryorexitgate/",
    "/autonomous-store/sdc/paymentreaders/",
    "/autonomous-store/sdc/gondola/",
    "/autonomous-store/sdc/smartShelf/",
    "/autonomous-store/sdc/camera/",
    "/autonomous-store/sdc/storedevices/",
    "/autonomous-store/livemonitoring/",
    "/planogram/",
    "/reports/salesSummaryReport/",
    "/reports/inventoryReport/",
    "/alert/newAlert/",
    "/alert/configuration/",
    "/alert/monitor/",
  ]

  return NAV_URL_SAAS_API_COMMON_CHECK_PATH.some((path) =>
    window?.location?.pathname.includes(path)
  )
}
export const getAddOnHeadersGlobal = (config = {}, type = "normal-view") => {
  if (localStorage.getItem("sourceRole")?.includes("SaaS-Site-Admin")) {
    const list = [
      "portal/storage",
      "portal/vendor",
      "portal/store",
      "portal/product",
      "portal/gondola",
      "portal/smart",
      "portal/tenant",
      "portal/alert",
      "portal/sdc",
      "portal/wrapper",
      "portal/master",
      "portal/inventory",
      "portal/report",
      "portal/hil",
      "portal/paymentwrapper",
      "/getlocations",
      "/getProductById",
      "/getProducts",
      "/getProductAttributes",
      "/productCategory",
      "/getStorageUnits",
      "products/getAllBrands",
      "products/getAllManufacturers",
    ]

    console.log("config?.url", config)
    //baseURL
    let isValidFlag = list.some((path) => {
      return `${config?.baseURL || ""}${config?.url || ""}`.includes(path)
    })

    if (isValidFlag) {
      config.headers["admin"] = "saas"
    }
  }

  let tenantId = localStorage.getItem("sourceRole")?.includes("SaaS")
    ? localStorage.getItem("selectedDefaultTenantId") === null
      ? ""
      : localStorage.getItem("selectedDefaultTenantId")
    : localStorage.getItem("tenantId") === null
    ? ""
    : localStorage.getItem("tenantId")

  let realmId = localStorage.getItem("sourceRole")?.includes("SaaS")
    ? localStorage.getItem("selectedDefaultRealmValue") === null
      ? ""
      : localStorage.getItem("selectedDefaultRealmValue")
    : localStorage.getItem("X-KC-Realm-ID") === null
    ? ""
    : localStorage.getItem("X-KC-Realm-ID")

  // config.headers["X-Tenant-ID"] = localStorage.getItem("tenantId")
  config.headers["X-KC-Realm-ID"] = localStorage.getItem("X-KC-Realm-ID")
  config.headers["X-Tenant-ID"] = getFlagCheckPathSAAS()
    ? tenantId
    : localStorage.getItem("tenantId")

  if (
    localStorage.getItem("sourceRole")?.includes("SaaS") &&
    getFlagCheckPathSAAS()
  ) {
    config.headers["realm-id"] = getFlagCheckPathSAAS()
      ? realmId
      : localStorage.getItem("X-KC-Realm-ID")
    config.headers["tenant-id"] = getFlagCheckPathSAAS()
      ? tenantId
      : localStorage.getItem("tenantId")

    if (type === "saas-view") {
      if (
        localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
      ) {
        //skip
      } else {
        config.headers["X-KC-Realm-ID"] = localStorage.getItem(
          "defaultRealmIdSelect"
        )
        config.headers["realm-id"] = localStorage.getItem(
          "defaultRealmIdSelect"
        )
      }
    }
  } else if (
    localStorage.getItem("sourceRole")?.includes("Tenant Admin") &&
    getFlagCheckPathSAAS()
  ) {
    // debugger
    config.headers["realm-id"] = localStorage.getItem("X-KC-Realm-ID")
  } else {
  }

  if (type === "saas-view") {
    const requestPath = `${config?.baseURL || ""}${config?.url || ""}`
    if (requestPath.includes("/hil/")) {
      if (
        localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
      ) {
        //skip
      } else {
        config.headers["X-KC-Realm-ID"] = localStorage.getItem(
          "defaultRealmIdSelect"
        )
      }
    }
  }

  let x_kc_host = localStorage.getItem("sourceRole")?.includes("SaaS")
    ? localStorage.getItem("selectedDefaultTenantId") === null
      ? ""
      : "authdevdm.digitsquare.ai"
    : localStorage.getItem("X-KC-Host") === null
    ? "authdevdm.digitmart.ai"
    : localStorage.getItem("X-KC-Host")

  config.headers["X-KC-Host"] = localStorage.getItem("X-KC-Host")
}

export let getDynamicAPI_URL = (props) => {
  let isLocalCheckSubSASS = false
  let apiEndpointEnv = process.env.REACT_APP_API_ENDPOINT
  const { location = {} } = window

  /**
   * @TODO_DYNAMIC
   */

  let domainHostName = location?.host.includes("localhost")
    ? isLocalCheckSubSASS
      ? "devdm.digitsquare.ai"
      : "devdm.digitmart.ai"
    : location?.host
  return `https://api${domainHostName}/portal`
}

// export let getAddonHeaders = () => {
//   return {
//     country_code:
//       localStorage.getItem("country_code") === null
//         ? ""
//         : localStorage.getItem("country_code"),
//   }
// }

const readStoredCountryCode = () => {
  const selected = `${localStorage.getItem("country_code") || ""}`.trim()
  if (selected) return selected
  try {
    return `${
      JSON.parse(localStorage.getItem("tenantAddress") || "{}")?.country_code ||
      ""
    }`.trim()
  } catch (e) {
    return ""
  }
}

export const getAddonHeaders = () => {
  return {
    "country-code": readStoredCountryCode(),
  }
}

export const getAddOnHeaders = getAddonHeaders

export let getConfigAddonHeaders = (config = {}) => {
  if (config) {
    config.headers["country-code"] = readStoredCountryCode()
  }
}

let apiEndpoint = process.env.REACT_APP_API_ENDPOINT
apiEndpoint = getDynamicAPI_URL()

const API_BASE_URL = apiEndpoint
const API_BASE_ROLE_URL = apiEndpoint

export const API_URL = `${API_BASE_URL}` //Content Modal
export const SAMPLE_FILE_TEMPLATE = "/products/api/products/getFileTemplate"
export const API_URL_STORES = `${API_BASE_URL}`
export const API_URL_CUSTOMERS = `${API_BASE_URL}`
export const API_URL_CUSTOMERS_NO_PROXY = `${API_BASE_URL}`
export const API_URL_ROLES = `${API_BASE_ROLE_URL}`
export const API_URL_CUSTOMERS_COMMON = `${API_BASE_URL}`
export const API_URL_USER = `${API_BASE_URL}`
export const API_URL_PRICES = `${API_BASE_URL}`
export const API_URL_INVENTORY = `${API_BASE_URL}`
export const API_URL_LOC_HIERARCHY = `${API_BASE_URL}/store/api/stores/locationHierarchy`
export const API_URL_PRODUCT = `${API_BASE_URL}`
export const LOC_HIERARCHY_LIVE_URLS = {
  baseURL: `${API_BASE_URL}`,
  endpoints: {
    getLocationsLiveMonitoring:
      "/usermanagement/api/usermanagement/liveMonitoring/store/info",
  },
}
export const LOC_HIERARCHY_URLS = {
  baseURL: `${API_BASE_URL}/store/api/stores`,
  endpoints: {
    getLocations: "/getlocations",
    getLocationGroups: "/getlocationgroups",
    getLocationHierarchy: "/locationHierarchy",
    create: "/createlocationHierarchy",
    updateHierarchy: "/updatelocationHierarchy/:hierarchyID",
    deleteHierarchy: "/deletelocationHierarchy/:hierarchyID",
    updateLocationHierarchyMappings: "/updateLocationHierarchyMappings",
    deleteLocationGroups: "/store/api/stores/deletelocationgroups",
    deleteLocation: "/store/api/stores/deletemany",
    searchLocations: "/searchlocations",
    searchKcLocations: "/searchLocations",
  },
}
export const STRG_HIERARCHY_URLS = {
  baseURL: `${API_BASE_URL}/product/api/storages`,
  endpoints: {
    getStorages: "/getStorageUnits",
    getLocations: "/getlocations",
    getLocationGroups: "/getlocationgroups",
    getLocationHierarchy: "/locationHierarchy",
    create: "/createlocationHierarchy",
    updateHierarchy: "/updatelocationHierarchy/:hierarchyID",
    deleteHierarchy: "/deletelocationHierarchy/:hierarchyID",
    updateLocationHierarchyMappings: "/updateLocationHierarchyMappings",
    deleteLocationGroups: "/store/api/stores/deletelocationgroups",
    deleteLocation: "/store/api/stores/deletemany",
    searchLocations: "/searchlocations",
    searchKcLocations: "/searchLocations",
  },
}

export const PRODUCT_CATEGORY_URLS = {
  baseURL: `${API_BASE_URL}/api/productcategory`,
  endpoints: {
    getAll: "/getall",
    create: "/create",
    fetchCategory: "/:categoryID",
    updateCategory: "/update/:categoryID",
    deleteCategory: "/delete/:categoryID",
  },
}

export const PRODUCT_DATA_URLS = {
  baseURL: `${API_BASE_URL}/product/api/products`,
  endpoints: {
    getProducts: "/getProducts",
    exportAllProduct: "/exportAllProduct",
    getProductCategories: "/productCategory",
    createCategory: "/createProductCategory",
    updateCategory: "/updateProductCategory",
    deleteCategory: "/deleteProductCategory",
    getAllWithPagination: "/paginate",
    getAllProductGroupsWithPagination: "/getproductgroups",
    deleteProductMany: "/product/api/products/deletemany",
    deleteProductGroups: "/product/api/products/deleteProductGroups",
    getProductById: "/getProductById",
    updateProduct: "/update",
    searchAttributes: "/searchAttributes",
    updateProductCategoryMappings: "/updateProductCategoryMappings",
    getProductCategoryById: "/getProductCategoryById",
    searchProducts: "/searchProducts",
    getProductsAttribute: "/getProductAttributes",
    createProductAttribute: "/createProductAttribute",
    getProductAttrById: "/productattribute",
    updateProductAttribute: "/updateProductAttribute",
    bulkUploadShekelProducts: "/bulkUploadShekelProducts",
  },
}
export const OFFERS_DATA_URLS = {
  baseURL: `${API_BASE_URL}/product/api/products`,
  subBaseURL: `${API_BASE_URL}`,
  endpoints: {
    deleteOffersMany: "/vendor/api/offer/delete",
    getOffers: "/vendor/api/offer/all",
    createOffers: "/vendor/api/offer/create",
    updateOffers: "/vendor/api/offer/update",
    deleteOffers: "/vendor/api/offer/delete",
    exportAllProduct: "/exportAllProduct",
    getProductCategories: "/productCategory",
    createCategory: "/createProductCategory",
    updateCategory: "/updateProductCategory",
    deleteCategory: "/deleteProductCategory",
    getAllWithPagination: "/paginate",
    getAllProductGroupsWithPagination: "/getproductgroups",
    deleteProductMany: "/product/api/products/deletemany",
    deleteProductGroups: "/product/api/products/deleteProductGroups",
    getProductById: "/getProductById",
    updateProduct: "/update",
    searchAttributes: "/searchAttributes",
    updateProductCategoryMappings: "/updateProductCategoryMappings",
    getProductCategoryById: "/getProductCategoryById",
    searchProducts: "/searchProducts",
    getProductsAttribute: "/getProductAttributes",
    createProductAttribute: "/createProductAttribute",
    getProductAttrById: "/productattribute",
    updateProductAttribute: "/updateProductAttribute",
    bulkUploadShekelProducts: "/bulkUploadShekelProducts",
  },
}
export const DISCOUNTS_DATA_URLS = {
  baseURL: `${API_BASE_URL}/product/api/products`,
  subBaseURL: `${API_BASE_URL}`,
  endpoints: {
    deleteOffersMany: "/vendor/api/discount/delete",
    getOffers: "/vendor/api/discount/all",
    createOffers: "/vendor/api/discount/create",
    updateOffers: "/vendor/api/discount/update",
    deleteOffers: "/vendor/api/discount/delete",
    exportAllProduct: "/exportAllProduct",
    getProductCategories: "/productCategory",
    createCategory: "/createProductCategory",
    updateCategory: "/updateProductCategory",
    deleteCategory: "/deleteProductCategory",
    getAllWithPagination: "/paginate",
    getAllProductGroupsWithPagination: "/getproductgroups",
    deleteProductMany: "/product/api/products/deletemany",
    deleteProductGroups: "/product/api/products/deleteProductGroups",
    getProductById: "/getProductById",
    updateProduct: "/update",
    searchAttributes: "/searchAttributes",
    updateProductCategoryMappings: "/updateProductCategoryMappings",
    getProductCategoryById: "/getProductCategoryById",
    searchProducts: "/searchProducts",
    getProductsAttribute: "/getProductAttributes",
    createProductAttribute: "/createProductAttribute",
    getProductAttrById: "/productattribute",
    updateProductAttribute: "/updateProductAttribute",
    bulkUploadShekelProducts: "/bulkUploadShekelProducts",
  },
}

export const INVENTORY_DATA_URLS = {
  baseURL: `${API_BASE_URL}/inventory/api/inventory`,
  endpoints: {
    bulkUploadInventoryStatus: "/api/kc/getBulkUploadInventoryCountStatus",
    bulkExportInventoryStatus: "/api/kc/getInventoryCountExportStatus",
    archieveInventoryStatus: "/api/kc/archiveInventoryCountStatus",
    bulkUploadInventoryData: "/api/kc/bulkUploadInventoryCount",
    bulkExportInventoryData: "/api/kc/exportAllInventoryCount",
    bulkUploadInventoryLogs: "/api/kc/getInventoryCountUploadLogList",
    getSupplierList: "/api/supplier/getsupplierlist",
    getSupplierType: "api/getsuppliertype",
    createSupplier: "/api/supplier/create",
    deleteSuppliers: "/api/supplier/deletemany",
    getSupplierById: "/api/supplier/getsupplier/",
    updateSupplierById: "/api/supplier/update/",
    getPurchaseList: "/api/kc/purchase/list",
    getPurchaseStatusList: "/api/getpurchasestatus",
    createPurchaseOrder: "/api/kc/purchase/create",
    updatePurchaseOrder: "/api/kc/purchase/update/",
    getPurchaseOrderById: "/api/kc/purchase/get/",
    deletePurchaseOrders: "/api/kc/purchase/deletemany",
    exportPurchaseOrders: "/api/kc/purchase/export",
    getBulkUploadPurchaseStatus: "/getBulkUploadPurchaseStatus",
    archivePurchaseStatus: "/archivePurchaseStatus",
    bulkUploadPurchaseProducts: "/api/kc/purchase/bulkUploadPurchaseProducts/",
    getPurchaseUploadLogList: "/getPurchaseUploadLogList",
    exportInventoryCurrentStock: "/inventory/stock/export",
  },
}
